export interface IStartParams {
    startBot: string | undefined,
    additionaldata: string | undefined,
    utmLabels: IUtmLabels | undefined
}

export interface IUtmLabels {
    Utm_source: String;
    Utm_medium: String;
    Utm_campaign: String;
    Utm_content: String;
    Utm_term: String;
}

export const getUtmLabelParams = () => {
    return [
        "Utm_source",
        "Utm_medium",
        "Utm_campaign",
        "Utm_content",
        "Utm_term"
    ]
}
